enum ViewerType {
	PDF = "pdf",
	IMAGE = "image",
	TEXT = "text",
	ZIP = "zip",
	HTML = "html",
	RTF = "rtf",
	TIFF = "tiff",
	HEIC = "heic",
	DEFAULT = "default"
}

export default ViewerType;